export default class WebSocketAckDto {	
	public id = '';
	public send = Date.now();
	public replyTo = '';
	public ack = '';
}